export const buttonStyles = [
  {
    transform: "translate(0px, 0px) rotate(0rad) skewX(0rad) scale(1, 1)", 
    width: "36px", 
    left: "2px", 
    top: "7px"
  },
  {
    transform: "translate(0px, 0px) rotate(0rad) skewX(0rad) scale(1, 1)", 
    width: "36px", 
    left: "2px", 
    bottom: "7px"
  },
  {
    transform: "rotate(-0.7854rad)", 
    width: "24px", 
    left: "-1px", 
    top: "11px"
  },
  {
    transform: "rotate(0.7854rad)", 
    width: "24px", 
    left: "-1px",
    bottom: "11px"
  }  
]


// WEBPACK FOOTER //
// ./src/containers/NavigationBar/constants.js